export default "__VITE_ASSET__DWGrOT4c__"